import React,{useEffect,useState, Fragment} from 'react';
import {useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

const ValidacionesR = Yup.object().shape({

    description: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(256, "No puede tener mas de 60 caracteres"),
     
  });
  
const AgregarRecomendacion = ({
  children,
  toUser,
  setRecommendations = () => {}
})=>{

    const handleClose = () => setShow(false);
    const [show, setShow] = useState(false);
  
    function sendRecommendation(values) {
      let descriptionText = {
        toUser: toUser,
        description: values.description,
      };
      setRecommendations(true)
      axios
        .post("recommendation/create", descriptionText)
        .then((result) => {
          if (result.status === 201) {
  
            toast.success("Tu recomendacion ha sido enviada", {
              duration: 6000,
            });
            setShow(false)
  
          }
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            toast.error(error.response.data.message);
          } else {
            toast.error(error.response.data.message);
          }
        });
    }
    
    return (
     <Fragment>
       <button id="myBtn" className="btn-recommendation" >{children }<i class="fas fa-plus"/></button>
    <Modal
          show={show}
          keyboard={false}
          dialogClassName="kr-modal"
          onHide={handleClose}
        >
          <Modal.Header closeButton>
          </Modal.Header>
     <Modal.Body>
     <div className="form form--white ">
                        <Formik
                          initialValues={{
                            description: '',
                          }}
                          onSubmit={(values, { setSubmitting }) => {
                            setSubmitting(true);
                            sendRecommendation(values);
                            setSubmitting(false);
                          }}
                          validationSchema={ValidacionesR}
                        >
                          {({ errors, touched, isSubmitting }) => (
                            <Form>
                              <div className="div__wrapper">
                                <div className="form__title text-center">
                                  Enviar una recomendacion
                                </div>
  
                                <div className="form__row">
                                  <div className="col-sm-12 ">
                                    <label htmlFor="description">Descripcion</label>
                                    <Field
                                      type="text"
                                      name="description"
                                      id="description"
                                      required
                                    ></Field>
                                    {errors.description && touched.description && (
                                      <span className="form__validation form__validation--error">
                                        {errors.description}
                                      </span>
                                    )}
                                  </div>
  
                                </div>
  
    
                                <div className="form__row">
                                  <button
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="btn btn--gradient btn__icon btn__icon--door"
                                  >
                                    Enviar
                                  </button>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
     </Modal.Body>
  
        </Modal>
     </Fragment>
    )
  }
  
export default AgregarRecomendacion;